// extracted by mini-css-extract-plugin
export default {"orderedAt":"index-module__orderedAt___u4sin"};